import { Pipe, PipeTransform } from '@angular/core';
import * as moment from "moment";
import 'moment-timezone';

@Pipe({
  name: 'utcDateToUserTimeZone'
})
export class UtcDateToUserTimeZonePipe implements PipeTransform {

  transform(value: any, format: string, timeZone: string = 'UTC'): any {
    if (!value) return null;

    const utcMoment = moment.utc(value);
    const userTimeZoneMoment = utcMoment.tz(timeZone);
    return userTimeZoneMoment.format(format);
  }

}
